import { render, staticRenderFns } from "./MyMenu.vue?vue&type=template&id=81ddc6ce&scoped=true&"
import script from "./MyMenu.vue?vue&type=script&lang=js&"
export * from "./MyMenu.vue?vue&type=script&lang=js&"
import style0 from "./MyMenu.vue?vue&type=style&index=0&id=81ddc6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ddc6ce",
  null
  
)

export default component.exports